import React from 'react'

const MicroPhoneIcon = () => {
    return (
        <svg id="mic_none_black_24dp_2_" data-name="mic_none_black_24dp (2)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_207126" data-name="Path 207126" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_207127" data-name="Path 207127" d="M12,14a3,3,0,0,0,3-3V5A3,3,0,0,0,9,5v6A3,3,0,0,0,12,14ZM11,5a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm6,6A5,5,0,0,1,7,11H5a7,7,0,0,0,6,6.92V21h2V17.92A7,7,0,0,0,19,11Z" fill="rgba(26,26,26,0.8)" />
        </svg>
    )
}

export default MicroPhoneIcon
